/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    format, compareAsc, addMonths, addDays, startOfWeek, getWeek, startOfMonth, endOfMonth, getYear, isLastDayOfMonth, isSameMonth, getMonth,
} from 'date-fns';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    object, bool, func, string, shape, arrayOf, number, array,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import mbpLogger from 'mbp-logger';
import { parse } from 'qs';
// import getDeliveryCalendarByProduct from '../../../../../../apis/product-apis/getDeliveryCalendarByProduct';
import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager';
import { sanitizeContent } from '../../../../../../lib/sanitize';

import {
    getValidatedZipcode,
    getUserSubmittedProductFilterZipcode,
    getSubscriptionFrequencyData,
    getSSRDeviceType,
} from '../../../../../../state/ducks/App/App-Selectors';

import ServiceLabel from './Partials/ServiceLabel';
import UnavailableDateModal from './Partials/UnavailableDateModal';
import { getPresentationFamily, getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

import { checkDateHasBackUpProduct } from '../../../../../helpers/checkFptGptProductBackUp';
import determineIfPastCutoffTime from '../../../../../helpers/determineCutoffTime';

import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import AltCalendarWidget from './Partials/AltCalendarWidget';

import { errorActions } from '../../../../../../state/ducks/Common/ducks/Error';
import { updateOrder } from '../../../../../../state/ducks/MfeCheckout/ducks/Cart/ducks/UpdateCart/UpdateCart-Actions';

import {
    getIsPassportUserLoggedIn,
    getIsAuthenticatedStatus,
} from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

import {
    getCartError,
    getLoaderStatus,
    isCheckoutPage,
    getPmallSummaryInfo,
} from '../../../../../../state/ducks/Common/Common-Selectors';
import { addToCart, clearAddToCartError } from '../../../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getAddToCartError, getAddToCartLoaderStatus } from '../../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getPassportSubscriptionStatus } from '../../../../../../state/ducks/MfeCheckout/ducks/Passport/Passport-Selectors';

import noop from '../../../../../helpers/noop';
import { withAuth } from '../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { getFormatedDeliveryDate } from '../../../../../pages/Checkout/containers/EnterpriseCheckout/Common/PmallShippingMethod/Helper/helper';
import CalendarBanner from './Partials/CalendarBanner';
import availablityDeliveryCalendar from '../../../../../../apis/cart-service-apis/availablityDeliveryCalendar';
import { getOrderItemErrors } from '../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector';
import FlexibleShippingOptions from './Partials/FlexibleShippingOptions';

const styles = (theme) => ({
    closeModal: {
        position: 'absolute',
        fontWeight: 'normal',
        right: '12px',
        color: theme.palette.colorNeutral70,
        cursor: 'pointer',
    },
    modelHeader: {
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        textTransform: 'uppercase',
        color: theme.palette.cms?.primary || theme.palette.primary?.main || '#52297E',
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '15px 0px !important',
    },
    modelContainer: {
        [theme.breakpoints.up('sm')]: {
            top: '10% !important',
        },
        '& div': {
            alignItems: 'start',
            '& div': {
                maxHeight: '100%',
                height: '100%',
                width: '100%',
                margin: '0px',
                alignItems: 'start',
                borderRadius: '0px',
                maxWidth: '670px !important',
                position: 'relative',
                [theme.breakpoints.up('sm')]: {
                    height: 'auto',
                },
            },
        },
    },
    monthTitle: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: '700',
        textTransform: 'uppercase',
        margin: '14px 0px 16px 0 !important',
    },
    daysRow: {
        display: 'flex !important',
    },
    weekDayV2: {
        display: 'inline-block',
        textAlign: 'center',
        marginLeft: '5%',
        marginRight: '4%',
        fontSize: '14px',
        fontWeight: '400',
        [theme.breakpoints.down(1025)]: {
            marginLeft: '0',
            marginRight: '0',
            width: '13.5%',
        },
        [theme.breakpoints.down(600)]: {
            marginLeft: '2px',
        },
    },
    dateIcon: {
        position: 'absolute',
        right: 0,
        top: 0,
        height: '20px',
        width: '16px',

        '&-unavailable': {
            opacity: 0.4,
            filter: 'grayscale(1)',
        },

        [theme.breakpoints.down(480)]: {
            height: '15px',
            width: '11px',
        },
    },
    weekDayName: {
        display: 'flex !important',
        flexWrap: 'wrap',
    },
    dateAvailableV2: {
        background: theme.palette.colorPrimaryContrast,
        cursor: 'pointer',
        border: `1px solid  ${theme.palette.grey10}`,
        width: '62px',
        display: 'flex',
        textAlign: 'center',
        margin: '1%',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 0px',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: '16px',
        height: '46px',
        flexDirection: 'column',
        '&:hover': {
            fontWeight: '600',
        },
        [theme.breakpoints.down(1025)]: {
            height: '40px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            fontWeight: 'bold',
            padding: '6px 0',
            lineHeight: '14px',
        },
        [theme.breakpoints.down(550)]: {
            width: '11.6%',
            height: '37px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            fontWeight: 'bold',
            padding: '6px 0',
            lineHeight: '14px',
        },
    },
    dateSurcharge: {
        color: '#2F7BA6',
        '@media (hover: hover)': {
            '&:hover': {
                fontSize: '0.75rem',
                fontWeight: '600',
                [theme.breakpoints.down(560)]: {
                    fontSize: '0.55rem',
                },
            },
        },
    },
    surchargeV2: {
        fontSize: '8px',
        margin: '4px auto 0 auto',
        lineHeight: '8px',
        fontWeight: 400,
        '@media(min-width: 600px)': {
            fontSize: '10px',
        },
        [theme.breakpoints.up(1025)]: {
            fontSize: '12px',

        },
    },
    surcharge: {
        color: '#2F7BA6',
        fontSize: '8px',
        margin: '4px auto 0 auto',
        lineHeight: '8px',
    },
    noDateAvailableRedesign: {
        height: '46px',
        width: '62px',
        display: 'inline-block',
        textAlign: 'center',
        color: '#9e9e9e',
        margin: '1%',
        fontSize: '14px',
        fontWeight: '500',
        position: 'relative',
        padding: '8px 0px',
        '& notVisible': {
            visibility: 'hidden',
        },
        [theme.breakpoints.down(1025)]: {
            height: '40px',
        },
        [theme.breakpoints.down(500)]: {
            height: '37px',
            width: '11.6%',
        },
    },
    prevBtn: {
        position: 'absolute',
        left: '15px',
        color: theme.palette.cms?.primary || theme.palette.primary?.main || '#52297E',
        fontSize: '14px',
        fontWeight: '700',
        cursor: 'pointer',
        '&::before': {
            content: '"<"',
            paddingRight: '7px',
        },
    },
    nextBtn: {
        position: 'absolute',
        right: '15px',
        color: theme.palette.cms?.primary || theme.palette.primary?.main || '#52297E',
        fontSize: '14px',
        fontWeight: '700',
        cursor: 'pointer',
        marginRight: '20px',
        '&::after': {
            content: '">"',
            paddingLeft: '8px',
        },
        [theme.breakpoints.down(600)]: {
            marginRight: '10px',
        },
    },
    spinnerContainer: {
        width: '100%',
        // textAlign: 'center',
    },
    spinner: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        top: '50%',
        left: '50%',
        zIndex: '10000',
    },
    mobBottomDivMobile: {
        margin: '0px 0px 15px !important',
        [theme.breakpoints.up('sm')]: {
            display: 'none !important',
        },
    },
    mobBottomDiv: {
        margin: '0px 0px 15px !important',
        '& .mobBottomLeftV2': {
            [theme.breakpoints.up(600)]: {
                width: '65% !important',
            },
        },
        '& .mobBottomRightV2': {
            float: 'right',
            marginRight: '25px',
            maxWidth: '156px',
            marginLeft: '0px !important',
            [theme.breakpoints.down(445)]: {
                marginRight: '0px',
            },
        },
    },
    mobBottomRight: {
        display: 'inline-block',
        '& img': {
            width: 'auto',
            padding: '15px 0px',
        },
        [theme.breakpoints.down(600)]: {
            width: '45%',
        },
    },
    mobBottomLeft: {
        top: '15px',
        width: '53% !important',
        display: 'inline-block',
        verticalAlign: 'top',
    },
    leftCalendar: {
        [theme.breakpoints.up(960)]: {
            width: '66% !important',
            float: 'left',
            margin: '20px 0px 20px 5px !important',
        },
        [theme.breakpoints.up(600)]: {
            // width: '66% !important',
            float: 'left',
            margin: '20px 0px 20px 5px !important',
        },
        '&::before': {
            width: '100%',
            height: '100%',
            content: '""',
        },
    },
    calendarMobileLayout: {
        [theme.breakpoints.up('sm')]: {
            padding: '0px 40px',
            margin: '0px 0px 20px 5px !important',
        },
    },
    calendarBoxV2: {
        paddingBottom: '0!important',
    },
    rightCalendar: {
        [theme.breakpoints.up('sm')]: {
            width: '28% !important',
            float: 'left',
            margin: '8px !important',
            textAlign: 'center',
            borderRadius: '5px !important',
            border: `2px solid ${theme.palette.grey10}`,
            justifyContent: 'flex-start',
            padding: '4px !important',
            marginTop: '30px !important',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    rightTop: {
        [theme.breakpoints.up('sm')]: {
            borderBottom: `1px solid ${theme.palette.grey10}`,
            padding: '20px 0px !important',
        },
        '& p': {
            [theme.breakpoints.up('sm')]: {
                margin: '0px',
                fontSize: '14px',
            },
        },
        '& span': {
            [theme.breakpoints.up('sm')]: {
                fontSize: '18px',
                fontWeight: '700',
                textTransform: 'uppercase',
            },
        },
    },
    closeModalEmpty: {
        minHeight: 40,
        border: 0,
    },
    cartError: {
        fontSize: 15,
        marginTop: 0,
        textAlign: 'center',
        padding: '5px',
    },
    errorIcon: {
        color: theme.palette.error.main,
        verticalAlign: 'bottom',
    },
    rightLogoImage: {
        width: '100%',
    },
    mobMark: {
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            fontWeight: '400',
            padding: '10px 0px 10px 8px !important',
            width: 'initial !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
        },
    },
    deliveryImg: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
        },
        '& img': {
            [theme.breakpoints.up('sm')]: {
                width: 'auto !important',
            },
        },
    },
    standardCharge: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
            fontSize: '14px',
        },
    },
    rightLogo: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px 10px  !important',
        },
    },
    altCalendarDesktop: {
        [theme.breakpoints.down(480)]: {
            display: 'none',
        },
    },
    altCalendarMobile: {
        textAlign: 'center',
        marginBottom: '15px',
    },
    loadingFadeOut: {
        '&::before': {
            width: '100%',
            height: '100%',
            content: '""',
            zIndex: '100',
            backgroundColor: 'rgba(255,255,255,0.5)',
            position: 'absolute',
        },
    },
    maxClosedWidth: {
        '& div': {
            '& div': {
                maxWidth: '300px !important',
                borderRadius: 2,
                paddingBottom: 10,
            },
        },
    },
    todayTomDateNotAvailContainer: {
        width: '100%',
        background: '#f4f2f7',
        '& p': {
            padding: '10px',
            margin: 0,
            textAlign: 'center',
            color: '#f71449',
            fontSize: '15px',
        },
    },
    negativeSurchargeMessage: {
        width: '100%',
        '& > p': {
            display: 'flex',
            margin: '10px 0',
            color: '#1F1F1F',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '18px',
            '& > span': {
                marginTop: '0px',
                marginBottom: '0px',
            },
            [theme.breakpoints.down(395)]: {
                fontSize: '13px',
            },
            [theme.breakpoints.down(376)]: {
                fontSize: '12px',
            },
        },
    },
    negativeSurchargeIcon: {
        marginLeft: '3px',
        display: 'flex',
        '& > img': {
            maxWidth: '100%',
        },
    },
    negativeSurchargeMessageV2: {
        margin: '0',
    },
    modelHeaderV2: {
        height: 'auto!important',
    },
    negativeSurchargeColor: {
        // color: '#2F7BA6',
    },
    hoverSurcharge: {
        '@media (hover: hover)': {
            '&:hover': {
                '& p': {
                    display: 'none',
                },
            },
        },
    },
    hoverSurchargeV2: {
        '&:hover': {
            '& p': {
                color: 'white',
                fontWeight: 'bold',
                fontSize: '15px',
            },
        },
    },
    renderSurchargeWithoutHover: {
        minHeight: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontWeight: 'bold',
        padding: '6px 0',
        lineHeight: '14px',
    },
    dialogTitle: {
        '& .mobBottomRight': {
            width: '47%',
            [theme.breakpoints.up(600)]: {
                width: '29%',
                marginLeft: '75px',
            },
        },
        '& .mobBottomLeftV2': {
            [theme.breakpoints.up(600)]: {
                width: '65%',
            },
        },
        '& .mobBottomRightV2': {
            float: 'right',
            marginRight: '25px',
            maxWidth: '156px',
            marginLeft: '0px !important',
            [theme.breakpoints.down(445)]: {
                marginRight: '0px',
            },
        },
    },
    divider: {
        minHeight: '1px',
        background: '#BFBFBF',
        height: 'auto!important',
        [theme.breakpoints.down('xs')]: {
            marginTop: '25px!important',
        },
    },
    bottomContent: {
        padding: '0 44px',
        height: 'auto!important',
        [theme.breakpoints.down('xs')]: {
            padding: '0 28px',
        },
    },
});

const WWW_WEEKDAY_SHORTNAMES_MON_START = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun',
];
const WWW_WEEKDAY_SHORTNAMES_SUN_START = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];

const MMMM_MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const MMMM_SHORT_MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
const z2fmt = (v) => (v < 10 ? '0' : '') + v; // e.g. '03', '12'
const formatDateYYYY_MM_DD = (d) => `${d.getFullYear()}-${z2fmt(d.getMonth() + 1)}-${z2fmt(d.getDate())}`; // e.g. '2019-11-01'
const formatDate_d_MMM_yy = (d) => {
    const dateArr = d.split('-');
    return `${Number(dateArr[2])}-${MMMM_SHORT_MONTH_NAMES[Number(dateArr[1]) - 1]}-${dateArr[0].substring(2, 4)}`; // e.g. '2019-11-01'
};

const yyyy_mm_ddToDate = (dateString) => {
    // YYYY-MM-DD date string to JS Date.  Made to avoid doing Date('YYYY-MM-DD') because that assumes UTC.
    const m = dateString.match(/^\s*(\d\d\d\d)-(\d\d?)-(\d\d?)\s*$/);
    if (m) {
        return new Date(m[1], m[2] - 1, m[3]);
    }
    return 0;
};
const getNow = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
}; // 12:00 midnight of current day
const firstOfNextMonth = (d) => addMonths(startOfMonth(new Date(d)), 1);
const firstofPrevMonth = (d) => {
    const m = d.getMonth();
    return m === 0
        ? new Date(d.getFullYear() - 1, 11, 1)
        : new Date(d.getFullYear(), m - 1, 1);
};
export class CalendarModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prevBtnCheck: false,
            surcharge: 'Standard Service Charge',
            now: '',
            end: '',
            spinnerActive: false,
            calendarIsLoading: false,
            focusedDate: null,
            flex: {
                flexActivated: false,
                flexData: {},
                selectedDate: null,
                showFlexPopup: '',
            },
            flexTaggingData: {},
            dateIcons: {},
            altCalendar: {
                altCalendarActivated: false,
                altCalendarData: null,
            },
            clickableUnavailableDates: {
                unavailableDateModalActive: false,
                clickableDates: null,
                fakeDateInfo: {},
            },
        };
        // The following object is instantiated outside of state so that assigment is syncronous.
        this.apiDateObj = {};
        this.negativeSurchargeAmount = null;
        this.negativeSurchargeDates = [];
        this.lockNegativeSurcharge = false;
        this.dataObject = null;
    }

    componentDidMount() {
        const {
            location, trackEvent, flags, deliveryType,
        } = this.props;
        if (deliveryType === 'GPT') {
            this.setState({
                surcharge: 'Standard Shipping Charge',
            });
        }
        if (location.pathname.includes('checkout') || location.pathname.includes('add-ons')) {
            this.getCalendarFromAPI();
        }

        const eventAction = flags[`is-floral-calendar-first-day-of-week-sunday-${deliveryType?.toLowerCase?.()}`] ? 'Calendar Week Variant' : 'Calendar Week Control';
        trackEvent({
            eventCategory: 'Test Impression',
            eventAction,
        });
    }

    componentDidUpdate(prevProps) {
        const { calendarIsLoading } = this.state;
        const {
            isOpen, cmsData, flags, selectedSku, zipCode, userSubmittedZip,
            isQuickviewOrigin, partNumber, sympathyValue,
        } = this.props;

        if (
            ((isOpen === true
                && isOpen !== prevProps.isOpen) || (isOpen && cmsData && !prevProps.cmsData))
            && calendarIsLoading === false
        ) {
            this.getCalendarFromAPI();
            this.apiDateObj = {};

            this.negativeSurchargeAmount = null;
            this.negativeSurchargeDates = [];
            this.lockNegativeSurcharge = false;
            this.dataObject = null;
        }
        if (!prevProps.cmsData && cmsData) {
            const dateIcons = {};
            const calenderDateIcon = cmsData?.entries?.[0]?.calendar_date_icons;
            const dateIconArray = calenderDateIcon?.[0]?.date && calenderDateIcon;

            if (!(['1', '2'].includes(selectedSku?.sympathyValue) || ['1', '2'].includes(sympathyValue)) && dateIconArray && dateIconArray.length > 0) {
                dateIconArray.forEach((dateInfo) => {
                    dateIcons[dateInfo.date] = dateInfo;
                });
            }
            if (Object.keys(dateIcons).length > 0) {
                this.setState({
                    dateIcons,
                });
            }
            const altCalendar = cmsData?.entries?.[0]?.alt_calendar;
            if (flags['is-alt-calendar-flow-enabled'] && altCalendar?.alt_calendar_start_date && altCalendar?.alt_calendar_end_date) {
                // ContentStack gives dates in the format of yyyy-mm-dd which is parsed in an inconsistent
                // way by JS.
                // need to convert the days to a format that is consistently parsed
                // yyyy/mm/dd
                const altCalendarStateVersion = { ...altCalendar };
                altCalendarStateVersion.alt_calendar_start_date = altCalendarStateVersion.alt_calendar_start_date.split('-').join('/');
                altCalendarStateVersion.alt_calendar_end_date = altCalendarStateVersion.alt_calendar_end_date.split('-').join('/');
                if (compareAsc(new Date(altCalendarStateVersion.alt_calendar_start_date), new Date(altCalendarStateVersion.alt_calendar_end_date)) < 1) {
                    // check to make sure the end day is the same day or later than the start day to prevent getting stuck in an infinite loop
                    this.setState({
                        altCalendar: {
                            altCalendarActivated: false,
                            altCalendarData: altCalendarStateVersion,
                        },
                    });
                }
            }

            const fakeFlexFlagIsActive = flags['is-unavailable-calendar-dates-clickable'] && !flags['is-new-flex-flows-enabled'];
            if (fakeFlexFlagIsActive) {
                const clickableUnavailableDates = cmsData?.entries?.[0]?.clickable_unavailable_dates;
                const isZipcodeRestrictionEnabled = clickableUnavailableDates?.is_zipcode_restriction_enabled;
                let restrictedZipcodes = null;
                let reconciledZipcode = userSubmittedZip;
                if (isQuickviewOrigin) reconciledZipcode = zipCode;
                if (isZipcodeRestrictionEnabled) {
                    // if this is active only show this experience in the specified zipcodes
                    restrictedZipcodes = clickableUnavailableDates.zipcodes_to_include.reduce((acc, zip) => ({ ...acc, [zip]: true }), {});
                }
                const isBasecodeExclusionActive = clickableUnavailableDates?.is_basecode_exclusion_active;
                let excludedBasecodes = null;
                if (isBasecodeExclusionActive) {
                    // if this is active, do not show this experience for specified basecodes
                    excludedBasecodes = clickableUnavailableDates.basecodes_to_exclude.reduce((acc, code) => ({ ...acc, [code]: true }), {});
                }
                if (clickableUnavailableDates?.dates_to_display?.length
                    && !(isZipcodeRestrictionEnabled && restrictedZipcodes && !restrictedZipcodes[reconciledZipcode])
                    && !(isBasecodeExclusionActive && excludedBasecodes && excludedBasecodes[partNumber])) {
                    const clickableDates = clickableUnavailableDates.dates_to_display.reduce((acc, dateObj) => {
                        const formattedDate = dateObj?.fake_available_date?.split('-')?.join('/');
                        return { ...acc, [formattedDate]: dateObj };
                    }, {});
                    this.setState({
                        clickableUnavailableDates: {
                            unavailableDateModalActive: false,
                            clickableDates,
                        },
                    });
                }
            }
        }
    }

    getCalendarFromAPI = async (startDate = formatDateYYYY_MM_DD(getNow())) => {
        const {
            locationType,
            userSubmittedZip,
            selectedItemId,
            brandId,
            setCalendarDataLoadingFlag,
            handleDeliveryAvailability,
            clearCartError,
            callClearAddToCartError,
            zipCode,
            isInternationalProduct,
            passportInCart,
            isPassportUser,
            isUserLoggedIn,
            location,
            subscriptionDetails,
            subscriptionTypeAttribute,
            flags,
            deliveryType,
            auth,
            trackEvent,
            ldClient,
        } = this.props;

        const jwt = await auth.getAccessTokenSafely();

        const today = new Date();

        let zipToSearch = userSubmittedZip;
        if (zipCode) {
            zipToSearch = zipCode;
        }

        // set zipcode as 00000 if the product is international
        zipToSearch = isInternationalProduct ? '00000' : zipToSearch;

        clearCartError({
            errType: 'cart',
            field: 'error',
        });

        callClearAddToCartError();

        // const startDate = '2020-05-01';

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedItemId.match(/[^-_]*$/);
        this.setState({ calendarIsLoading: true });

        let customerType = isUserLoggedIn ? 'R' : 'G';
        if (passportInCart || (isUserLoggedIn && isPassportUser)) {
            customerType = 'P';
        }

        let subscriptionTypeValue = null;
        if (flags['is-pdp-subscription-enabled']) {
            const searchQuery = parse(location?.search?.replace(/^\?/, '') || ''); // removing ? from the search string

            subscriptionTypeValue = (searchQuery?.subscription && subscriptionDetails.subscriptionType) ? subscriptionDetails.subscriptionType : null;
            if (subscriptionTypeAttribute && !subscriptionTypeValue) {
                subscriptionTypeValue = subscriptionTypeAttribute;
            }
        }
        // allows variantID to be set with flexTestID through Launch Darkly experiment to the delivery calendar API
        // so additional copy variations can be created via CMS without code changes
        let flexTestId = null;
        if (flags['is-flex-test-enabled']) {
            const flexTestImpression = (type, flexId) => (trackEvent({
                eventCategory: 'Test Impression',
                eventAction: `Experiment Flex Test ${type}`,
                eventLabel: `Flex Test ${type}: ${flexId}`,
                nonInteraction: true,
            }));

            if (ldClient?.variation?.('which-flex-test-gpt')?.variant && deliveryType === 'GPT') {
                flexTestId = ldClient?.variation?.('which-flex-test-gpt')?.variant;
                flexTestImpression(deliveryType, flexTestId);
            }
            if (ldClient?.variation?.('which-flex-test-fpt')?.variant && deliveryType === 'FPT') {
                flexTestId = ldClient?.variation?.('which-flex-test-fpt')?.variant;
                flexTestImpression(deliveryType, flexTestId);
            }
        }

        // if it's the last day of the month and it's after the cutoff time the calendar API
        // only gives back one month of dates. However, the calendar only displays the 'next' button to browse
        // additional months if there are dates in a second month that come back from the API
        // Below checks if it's both the last day of the month and is past the cutoff time
        // if so, query the calendar for the first day of the next month which will correctly
        // return two months of data from the delivery calednar API
        // only do this if the startDate is same as today Date
        let startDeliveryDate = formatDate_d_MMM_yy(startDate);

        if (
            (startDate === formatDateYYYY_MM_DD(today))
            && isLastDayOfMonth(today)
            && (
                (deliveryType === 'FPT' && determineIfPastCutoffTime())
                || (deliveryType === 'GPT')
            )
        ) {
            startDeliveryDate = format(addDays(today, 1), 'd-MMM-yy');
        }

        availablityDeliveryCalendar({
            env: {},
            jwtToken: jwt,
            brandCode: brandId,
            productCode: itemSku?.[0],
            locationType,
            zipCode: zipToSearch,
            startDate: startDeliveryDate,
            variantId: flexTestId || null,
            customerType,
        })
            .then(({ data }) => {
                setCalendarDataLoadingFlag(false);
                this.setState({ calendarIsLoading: false });
                if (!data?.response?.calendarDates?.length) {
                    handleDeliveryAvailability(false);
                    return;
                }
                this.generateState(data.response.calendarDates);
            })
            .catch((err) => {
                setCalendarDataLoadingFlag(false);
                this.setState({ calendarIsLoading: false });
                handleDeliveryAvailability(false);
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'availablityDeliveryCalendar - cart services',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    zipCode: zipToSearch,
                    locationType,
                    startDate,
                });
            });
    };

    determineNow = (apiResponse) => {
        // by default the first day shown on the calendar is the beginning of the week of the first availalbe date
        // from the delivery calendar API
        // However sometimes the desired behavior is to show some additional weeks
        // even if all dates for those weeks are unavailable. is-floral-calendar-built-on-current-date controls this behavior
        // if the flag is enabled this function checks to see if the current month is the same as the month from the delivery
        // calendar API. If it is the same month then the first date shown in the calendar is the beginning of the current week
        // not the beginning of the first week with product availability
        const { flags } = this.props;
        const isLeadTimeEnabled = flags['is-floral-calendar-built-on-current-date'];
        return (
            (new Date().getFullYear()) === (new Date(yyyy_mm_ddToDate(apiResponse[0].deliveryDate).getFullYear()))
            && getMonth(new Date()) === getMonth(new Date(yyyy_mm_ddToDate(apiResponse[0].deliveryDate)))
            && isLeadTimeEnabled
        ) ? new Date() : yyyy_mm_ddToDate(apiResponse[0].deliveryDate);
    }

    generateState = (apiResponse) => {
        this.generateCalendarObject(apiResponse);

        this.setState(
            {
                // see comments on function for more details
                now: this.determineNow(apiResponse),
                end: yyyy_mm_ddToDate(
                    apiResponse[apiResponse.length - 1].deliveryDate,
                ),
                spinnerActive: false,
            },
            this.checkPrevButton,
        );
        if (!this.lockNegativeSurcharge) {
            // to avoid date collection after first list
            this.lockNegativeSurcharge = true;
        }
    };

    isCalendarV2Enabled = () => {
        const { flags } = this.props;
        return flags['is-calendar-and-flex-redesign-enabled'];
    }

    generateCalendarObject = (apiResponse) => {
        const { altCalendar: { altCalendarData } } = this.state;

        apiResponse.forEach((date) => {
            this.apiDateObj[date.deliveryDate] = date;
        });
        if (altCalendarData && this.determineIfAltCalendarDatesAreInFuture(altCalendarData)) {
            // if the last date to check for the alt calendar already happened then the alt calendar should not activate
            let allDatesAreUnAvailable = true;
            let dayTracker = new Date(altCalendarData.alt_calendar_start_date);
            while (compareAsc(new Date(dayTracker), new Date(altCalendarData.alt_calendar_end_date)) < 1) {
                // loop through the all dates between alt cal start date and alt cal end date
                if (this.apiDateObj[format(dayTracker, 'yyyy-MM-dd')]) {
                    // if there is a date that is available among between alt start and end
                    // set allDatesAreUnAvailable to false and don't trigger alt calendar experience
                    allDatesAreUnAvailable = false;
                }
                dayTracker = addDays(new Date(dayTracker), 1);
            }
            if (allDatesAreUnAvailable === true) {
                this.setState({
                    altCalendar: {
                        altCalendarActivated: true,
                        altCalendarData,
                    },
                });
            }
        }
    };

    determineIfAltCalendarDatesAreInFuture = (altCalendarData) => {
        if (compareAsc(new Date(altCalendarData.alt_calendar_end_date), new Date()) < 1) {
            return false;
        }
        return true;
    }

    isFinalDateDisplayed = (calendar) => {
        const { flags } = this.props;
        if (flags?.['is-calendar-show-week-five-enabled']) {
            const { end } = this.state;
            const calendarWeeks = Object.keys(calendar || {});
            const calendarEndWeek = calendar?.[calendarWeeks?.[calendarWeeks?.length - 1]] || [];
            const calendarEndDate = calendarEndWeek?.[calendarEndWeek?.length - 1]?.date || null;
            const comparison = compareAsc(new Date(end), new Date(calendarEndDate));
            if (comparison > 0) {
                return true;
            }
        }
        return false;
    }

    generateDaysByRange = (start, end) => {
        const days = [];
        if (start && end) {
            let currentDate = yyyy_mm_ddToDate(start);
            while (compareAsc(currentDate, addDays(yyyy_mm_ddToDate(end), 1)) === -1) {
                days.push(formatDateYYYY_MM_DD(currentDate));
                currentDate = addDays(currentDate, 1);
            }
        }
        return days;
    }

    generateCalendar = (now, end, startDayOfWeek) => {
        const { flags } = this.props;
        let calendarDay = startOfWeek(new Date(now), { weekStartsOn: startDayOfWeek });
        const endDay = endOfMonth(end);
        const calendarDays = {};
        const weekCounter = [];
        const weekDaysCounter = {};
        const DayofMonth = format(new Date(now), 'dd');
        const DayofWeek = format(new Date(now), 'eee');
        while (compareAsc(new Date(calendarDay), new Date(endDay)) === -1) {
            const weekNumber = getWeek(new Date(calendarDay), { weekStartsOn: startDayOfWeek });
            if (flags?.['is-calendar-show-week-five-enabled']) {
                if (typeof weekDaysCounter[`week-${weekNumber}`] === 'undefined') {
                    weekDaysCounter[`week-${weekNumber}`] = [];
                }
                weekDaysCounter[`week-${weekNumber}`].push(weekNumber);
                weekCounter.push(weekNumber);
            }
            if (!calendarDays[weekNumber]) {
                calendarDays[weekNumber] = [];
            }
            if (!this.apiDateObj[formatDateYYYY_MM_DD(calendarDay)]) {
                calendarDays[weekNumber].push({
                    date: new Date(calendarDay),
                    available: false,
                });
            } else {
                calendarDays[weekNumber].push({
                    date: new Date(calendarDay),
                    available: true,
                    data: this.apiDateObj[formatDateYYYY_MM_DD(calendarDay)],
                });
            }
            calendarDay = addDays(new Date(calendarDay), 1);
            if (flags?.['is-calendar-show-week-five-enabled'] && (DayofMonth === '01' && (DayofWeek === 'Sat' || DayofWeek === 'Fri') && startDayOfWeek === 0 ? [...new Set(weekCounter)].length > 5 : [...new Set(weekCounter)].length > 4) && weekDaysCounter[`week-${weekNumber}`]?.length === 7) {
                break;
            }
        }
        return calendarDays;
    };

    generateMonth = (calendar, startWeek, endWeek) => {
        const month = [];
        let weekTracker = startWeek;
        let isAlreadyReset = false;

        while (weekTracker !== endWeek + 1) {
            if (calendar[weekTracker]?.length > 0) {
                month.push(calendar[weekTracker]);
            }

            weekTracker += 1;
            if (weekTracker === 53 && endWeek !== 53 && !isAlreadyReset) {
                weekTracker = 1;
                isAlreadyReset = true;
            }
        }
        return month;
    };

    checkPrevButton = () => {
        const { now } = this.state;
        if (now.getMonth() === getNow().getMonth() && now.getYear() === getNow().getYear()) {
            this.setState({ prevBtnCheck: false });
        } else {
            this.setState({ prevBtnCheck: true });
        }
    };

    preMonth = () => {
        const { now } = this.state;
        this.setState({
            spinnerActive: true,
        });
        this.getCalendarFromAPI(formatDateYYYY_MM_DD(firstofPrevMonth(now)));
    };

    nextMonth = () => {
        const { now } = this.state;
        this.setState({
            spinnerActive: true,
        });
        this.getCalendarFromAPI(formatDateYYYY_MM_DD(firstOfNextMonth(now)));
    };

    flexAddToCart = (flexDate) => {
        const { flex: { selectedDate } } = this.state;
        const {
            actionAddToCart,
            actionUpdateOrder,
            selectedItemId,
            brandId,
            history,
            userSubmittedZip,
            locationType,
            location,
            orderItemId,
            close,
            deliveryType,
            ageDetails,
            partNumber,
            sympathyValue,
            pageType,
            isInternationalProduct,
            internationalCountry,
            isPassportBundleItem,
            personalization,
            movieSelected,
            isPassportBundleProduct,
            selectedSku,
            hasWine,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            handleMiniCartModalClick,
            enableMinicart,

            // category quickview
            zipCode,
            isQuickviewOrigin,
            quickviewSelectDate,
            subscriptionFrequencyData,
            flags,
            showWrapup,
        } = this.props;
        let brandCode = brandId;
        let reconciledZipcode = userSubmittedZip;
        if (isQuickviewOrigin) reconciledZipcode = zipCode;

        if (isQuickviewOrigin || (!location.pathname.includes('checkout') && !location.pathname.includes('add-ons'))) {
            let categoryId = null;
            let categoryName = null;
            let categoryPath = null;
            // if the user direct loads a product page there will be no categoryId
            if (location) {
                categoryPath = location.pathname;

                if (location.state) {
                    const { fromCategoryPage } = location.state;

                    if (fromCategoryPage) {
                        if (location.state.categoryId) {
                            categoryId = location.state.categoryId;
                        }

                        if (location.state.categoryPath) {
                            categoryPath = location.state.categoryPath;
                        }

                        if (location.state.categoryName) {
                            categoryName = location.state.categoryName;
                        }
                    }
                }
            } else {
                categoryId = null;
            }

            let skipAddons = false;
            let passportBundle = {};
            // sympathyValue: '1' - Home, '2' - Funeral
            if ((location.state && location.state.skipAddons) || (sympathyValue === '1' || sympathyValue === '2')) {
                skipAddons = true;
            }
            // if passportBundle flow; redirect to /checkout
            if (isPassportBundleProduct?.enable) {
                skipAddons = true;
                passportBundle = {
                    enable: true,
                    passportSku: isPassportBundleProduct?.passportSku,
                };
            }

            const attributes = [];
            // Attr: categoryId
            if (categoryId) {
                attributes.push({
                    attributeName: 'categoryId',
                    attributeValue: categoryId,
                });
            }

            // Attr: categoryIdent
            if (categoryName) {
                attributes.push({
                    attributeName: 'categoryIdent',
                    attributeValue: categoryName,
                });
            }

            // Attr: categoryPath
            if (categoryPath) {
                attributes.push({
                    attributeName: 'categoryPath',
                    attributeValue: categoryPath,
                });
            }

            /* Feature - FPT / GPT - Back Up Product - Start */

            let productCode = selectedItemId;
            let productPartNumber = partNumber;

            const backUpProductBrandCode = selectedDate?.data?.backupSkuBrand;
            const backUpProductSkuCode = selectedDate?.data?.backupSkuCode;

            const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

            if (backUpProduct.hasProduct) {
                brandCode = backUpProductBrandCode;
                productCode = backUpProduct.productCode;
                productPartNumber = backUpProduct.productCode;
            }

            /* Feature - FPT / GPT - Back Up Product - End */
            let personalizationLines;
            if (personalization?.lineState) {
                personalizationLines = personalization.lineState?.map((line, i) => ({
                    perAttributeId: `${i + 1}`,
                    perAttributeValue: personalization.lineState[i].lineText,
                }));
            }

            const reqObj = {
                brandCode,
                productCode,
                quantity: 1,
                delivery: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'MM/dd/yyyy HH:mm:ss'),
                    zipCode: reconciledZipcode,
                    locationType,
                    deliverySLA: selectedDate.data.deliverySLA,

                },
                attributes,
            };

            if (flags['is-new-flex-flows-enabled']) {
                const flexVariantId = selectedDate?.data?.flexDetails?.variantId;
                const flexOptionKey = flexDate?.optionKey;
                const flexOptionId = flexDate?.optionCode;
                const forcedDate = flexDate?.forcedDelDate;

                if (!flexVariantId?.length || !flexOptionKey?.length || !flexOptionId?.length) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        message: 'New Flex Missing Data...',
                        flexVariantId,
                        flexOptionKey,
                        flexOptionId,
                    });
                }

                reqObj.delivery.flex = {
                    flexVariantId,
                    flexOptionKey,
                    flexOptionId,
                };

                if (selectedDate?.data?.flexDetails?.forceFlex === 'true') {
                    reqObj.delivery.deliveryDate = getFormatedDeliveryDate(forcedDate, 'MM/dd/yyyy HH:mm:ss');
                }
            } else {
                reqObj.delivery.flex = {
                    flexOptionId: flexDate.optionCode,
                    forcedDate: `${flexDate.forcedDelDate},${flexDate.flexDate}`,
                    flexMessages: flexDate.flexMsg.map((message) => ({
                        flxMsg: message.msgText,
                        flxMsgLoc: message.msgTypeLocation,
                    })),
                };
            }

            /**
             * Passing price rule id that will use to calculate the price dynamically based on the price rules
             */
            if (selectedSku?.priceRules?.length) {
                reqObj.priceRules = selectedSku.priceRules;
            }

            // International Product
            // send countryCode and zipcode
            // zipcode is set to 00000 if the product is international
            if (isInternationalProduct && internationalCountry) {
                reqObj.delivery.countryCode = internationalCountry;
                reqObj.delivery.zipCode = '00000';
            }

            if (personalizationLines) {
                reqObj.personalization = {
                    personalizationType: 'PRODUCT_PERSONALIZATION',
                    personalizationLines,
                };
            }

            if (
                ageDetails && ageDetails.birthDay && ageDetails.birthMonth
                && ageDetails.birthYear && ageDetails.minAge && hasWine === 'true'
            ) {
                reqObj.wineVerify = {
                    ...ageDetails,
                };
            }

            // subscription v1 - temporary hardcode
            if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
                reqObj.subscription = {
                    duration: 1,
                    interval: 30,
                    type: 'Basic',
                };
            }

            if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
                && subscription?.subscriptionCheckbox) {
                if (Object.keys(subscriptionFrequencyData).length > 0 && flags['is-subscription-frequency']) {
                    reqObj.subscription = {
                        duration: subscriptionFrequencyData.duration,
                        interval: subscriptionFrequencyData.subscriptionInterval,
                        type: subscriptionFrequencyData.subscriptionType,
                    };
                } else if (subscriptionDetails
                    && subscriptionDetails.subscriptionDurationKey
                    && subscriptionDetails.subscriptionFrequency
                    && subscriptionDetails.subscriptionType) {
                    let duration = subscriptionDetails.subscriptionDurationKey;
                    if (duration.indexOf('.') > 0) {
                        duration = duration.substring(0, duration.indexOf('.'));
                    }

                    let interval = subscriptionDetails.subscriptionFrequency;
                    if (interval.indexOf('.') > 0) {
                        interval = interval.substring(0, interval.indexOf('.'));
                    }

                    reqObj.subscription = {
                        duration,
                        interval,
                        type: subscriptionDetails.subscriptionType,
                    };
                }
            }

            // Category Page Quickview...
            // 1. Grab the data
            // 2. walk away
            if (isQuickviewOrigin) {
                const payload = {
                    reqObj,
                    history,
                    deliveryType, // FPT or GPT
                    categoryId,
                    productPartNumber,
                    skipAddons,
                    date: selectedDate.date,
                    categoryName,
                    categoryPath,
                    isPassportBundleItem,
                    movieSelected,
                    selectedSku,
                    passportBundle,
                    handleMiniCartModalClick,
                    enableMinicart,
                    close: noop,
                };
                // grab the data
                quickviewSelectDate(payload);
                // walk away
                close();
                return;
            }

            actionAddToCart(
                reqObj,
                history,
                deliveryType, // FPT or GPT
                categoryId,
                productPartNumber,
                skipAddons,
                selectedDate.date,
                categoryName,
                categoryPath,
                isPassportBundleItem,
                movieSelected,
                selectedSku,
                passportBundle,
                handleMiniCartModalClick,
                enableMinicart,
                close,
                showWrapup,
                null, // quickViewLocationType
                location,
            );
        } else {
            const payload = {
                updateDeliveryDate: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'MM/dd/yyyy HH:mm:ss'),
                    deliverySLA: selectedDate.data.deliverySLA,
                },
                orderItemId,
            };

            if (flags['is-new-flex-flows-enabled']) {
                const flexVariantId = selectedDate?.data?.flexDetails?.variantId;
                const flexOptionKey = flexDate?.optionKey;
                const flexOptionId = flexDate?.optionCode;
                const forcedDate = flexDate?.forcedDelDate;

                if (!flexVariantId?.length || !flexOptionKey?.length || !flexOptionId?.length) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        message: 'New Flex Missing Data...',
                        flexVariantId,
                        flexOptionKey,
                        flexOptionId,
                    });
                }

                payload.updateDeliveryDate.flex = {
                    flexVariantId,
                    flexOptionKey,
                    flexOptionId,
                };

                if (selectedDate?.data?.flexDetails?.forceFlex === 'true') {
                    payload.updateDeliveryDate.deliveryDate = getFormatedDeliveryDate(forcedDate, 'MM/dd/yyyy HH:mm:ss');
                }
            } else {
                payload.updateDeliveryDate.flex = {
                    flexOptionId: flexDate.optionCode,
                    forcedDate: `${flexDate.forcedDelDate},${flexDate.flexDate}`,
                    flexMessages: flexDate.flexMsg.map((message) => ({
                        flxMsg: message.msgText,
                        flxMsgLoc: message.msgTypeLocation,
                    })),
                };
            }

            const updateOrderProps = {
                page: location.pathname.includes('checkout') || location.pathname.includes('add-ons') ? pageType : null,
                updateType: 'delivery',
            };
            actionUpdateOrder(payload, updateOrderProps, close);
        }
    }

    selectDate = (selectedDate) => {
        const { clickableUnavailableDates } = this.state;
        const {
            actionAddToCart,
            actionUpdateOrder,
            selectedItemId,
            brandId,
            history,
            userSubmittedZip,
            locationType,
            location,
            orderItemId,
            close,
            deliveryType,
            ageDetails,
            partNumber,
            sympathyValue,
            pageType,
            trackEvent,
            isInternationalProduct,
            internationalCountry,
            isPassportBundleItem,
            personalization,
            movieSelected,
            isPassportBundleProduct,
            selectedSku,
            hasWine,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            handleMiniCartModalClick,
            enableMinicart,

            // category quickview
            zipCode,
            isQuickviewOrigin,
            quickviewSelectDate,

            // pmall
            pmallSummaryInfo,
            subscriptionFrequencyData,
            flags,
            showWrapup,
        } = this.props;
        let brandCode = brandId;
        const surcharge = selectedDate.data.surcharge;
        localStorage.setItem('totalSurcharge', surcharge);
        let reconciledZipcode = userSubmittedZip;
        if (isQuickviewOrigin) reconciledZipcode = zipCode;

        if (selectedDate.data.flexDetails?.option) {
            this.setState({
                flex: {
                    flexActivated: true,
                    flexData: selectedDate.data.flexDetails.option,
                    selectedDate,
                    showFlexPopup: selectedDate.data.flexDetails.showPopup,
                },
                flexTaggingData: {
                    zipcode: userSubmittedZip,
                    deliverytype: deliveryType,
                    date: format(selectedDate.date, 'yyyy-MM-dd'),
                },
            });
            trackEvent({
                eventCategory: 'Product Page',
                eventAction: `Flex Shown - ${format(selectedDate?.date, 'yyyy-MM-dd')}`,
                eventLabel: `${deliveryType} | ${userSubmittedZip}`,
            });
            return;
        }
        // isQuickviewOrigin check to allow QuickView on Cart Page.
        if (isQuickviewOrigin || (!location.pathname.includes('checkout') && !location.pathname.includes('add-ons'))) {
            let categoryId = null;
            let categoryName = null;
            let categoryPath = null;
            // if the user direct loads a product page there will be no categoryId

            if (location) {
                categoryPath = location.pathname;

                if (location.state) {
                    const { fromCategoryPage } = location.state;

                    if (fromCategoryPage) {
                        if (location.state.categoryId) {
                            categoryId = location.state.categoryId;
                        }

                        if (location.state.categoryPath) {
                            categoryPath = location.state.categoryPath;
                        }

                        if (location.state.categoryName) {
                            categoryName = location.state.categoryName;
                        }
                    }
                }
            } else {
                categoryId = null;
            }

            let skipAddons = false;
            let passportBundle = {};
            // sympathyValue: '1' - Home, '2' - Funeral
            if ((location.state && location.state.skipAddons) || (sympathyValue === '1' || sympathyValue === '2')) {
                skipAddons = true;
            }

            // if passportBundle flow; redirect to /checkout
            if (isPassportBundleProduct?.enable) {
                skipAddons = true;
                passportBundle = {
                    enable: true,
                    passportSku: isPassportBundleProduct?.passportSku,
                };
            }

            // Attributes
            const attributes = [];

            // Attr: categoryId
            if (categoryId) {
                attributes.push({
                    attributeName: 'categoryId',
                    attributeValue: categoryId,
                });
            }

            // Attr: categoryIdent
            if (categoryName) {
                attributes.push({
                    attributeName: 'categoryIdent',
                    attributeValue: categoryName,
                });
            }

            // Attr: categoryPath
            if (categoryPath) {
                attributes.push({
                    attributeName: 'categoryPath',
                    attributeValue: categoryPath,
                });
            }

            /* Feature - FPT / GPT - Back Up Product - Start */

            let productCode = selectedItemId;
            let productPartNumber = partNumber;

            const backUpProductBrandCode = selectedDate?.data?.backupSkuBrand;
            const backUpProductSkuCode = selectedDate?.data?.backupSkuCode;

            const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

            if (backUpProduct.hasProduct) {
                brandCode = backUpProductBrandCode;
                productCode = backUpProduct.productCode;
                productPartNumber = backUpProduct.productCode;
            }

            /* Feature - FPT / GPT - Back Up Product - End */
            let personalizationLines;
            if (personalization?.lineState) {
                personalizationLines = personalization.lineState?.map((line, i) => ({
                    perAttributeId: `${i + 1}`,
                    perAttributeValue: personalization.lineState[i].lineText,
                }));
            }
            const reqObj = {
                brandCode,
                productCode,
                quantity: 1,
                delivery: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'MM/dd/yyyy HH:mm:ss'),
                    zipCode: reconciledZipcode,
                    locationType,
                    deliverySLA: selectedDate.data.deliverySLA,
                },
                attributes,
            };

            if (!flags['is-new-flex-flows-enabled']
                && selectedDate?.data?.isClickableUnavailableDate
                && clickableUnavailableDates?.fakeDateInfo?.flex_option_id
                && clickableUnavailableDates?.fakeDateInfo?.flex_forceddeldate
                && clickableUnavailableDates?.fakeDateInfo?.flex_date) {
                const { fakeDateInfo } = clickableUnavailableDates;
                const splitForcedDelDate = fakeDateInfo.flex_forceddeldate?.split('-')?.join('/');
                const formattedForcedDelDate = format(new Date(splitForcedDelDate), 'dd-MMM-yy');
                const splitFlexDate = fakeDateInfo.flex_date?.split('-')?.join('/');
                const formattedSplitDate = format(new Date(splitFlexDate), 'dd-MMM-yy');
                reqObj.delivery.flex = {
                    flexOptionId: fakeDateInfo?.flex_option_id,
                    forcedDate: `${formattedForcedDelDate},${formattedSplitDate}`,
                };
            }

            if (selectedDate?.data?.isClickableUnavailableDate
                && clickableUnavailableDates?.fakeDateInfo?.flex_option_id
                && clickableUnavailableDates?.fakeDateInfo?.flex_forceddeldate
                && clickableUnavailableDates?.fakeDateInfo?.flex_date) {
                const { fakeDateInfo } = clickableUnavailableDates;
                const splitForcedDelDate = fakeDateInfo.flex_forceddeldate?.split('-')?.join('/');
                const formattedForcedDelDate = format(new Date(splitForcedDelDate), 'dd-MMM-yy');
                const splitFlexDate = fakeDateInfo.flex_date?.split('-')?.join('/');
                const formattedSplitDate = format(new Date(splitFlexDate), 'dd-MMM-yy');
                reqObj.delivery.flex = {
                    flexOptionId: fakeDateInfo?.flex_option_id,
                    forcedDate: `${formattedForcedDelDate},${formattedSplitDate}`,
                };
            }

            /**
             * Passing price rule id that will use to calculate the price dynamically based on the price rules
             */
            if (selectedSku?.priceRules?.length) {
                reqObj.priceRules = selectedSku.priceRules;
            }
            // International Product
            // send countryCode and zipcode
            // zipcode is set to 00000 if the product is international
            if (isInternationalProduct && internationalCountry) {
                reqObj.delivery.countryCode = internationalCountry;
                reqObj.delivery.zipCode = '00000';
            }

            /**
             * Handle req object personlization fields
             * for internal products
             */
            if (personalizationLines) {
                reqObj.personalization = {
                    personalizationType: 'PRODUCT_PERSONALIZATION',
                    personalizationLines,
                };
            }

            /**
             * Handle req object personalization fields
             * for external products ie. pmall
             *
             * this can be done by just checking for the presence
             * of a pmallSummaryInfo?.customizations.refnum
             * Get the attributes description and preview from the summary api.
             */
            if (pmallSummaryInfo?.customizations?.refnum) {
                const pmallLines = [
                    {
                        perAttributeId: 'description',
                        perAttributeValue: pmallSummaryInfo.customizations.description,
                    },
                    {
                        perAttributeId: 'previewUrl',
                        perAttributeValue: pmallSummaryInfo.customizations.imageURL,
                    },
                ];

                reqObj.personalization = {
                    personalizationType: 'EXTERNAL',
                    personalizationId: pmallSummaryInfo.customizations.refnum,
                    personalizationLines: pmallLines,
                };

                if (pmallSummaryInfo?.customizations?.addonCount) {
                    reqObj.personalization.addonCount = pmallSummaryInfo.customizations.addonCount;
                }
            }

            if (
                ageDetails && ageDetails.birthDay && ageDetails.birthMonth
                && ageDetails.birthYear && ageDetails.minAge && hasWine === 'true'
            ) {
                reqObj.wineVerify = {
                    ...ageDetails,
                };
            }

            // subscription v1 - temporary hardcode
            if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
                reqObj.subscription = {
                    duration: 1,
                    interval: 30,
                    type: 'Basic',
                };
            }

            if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
                && subscription?.subscriptionCheckbox) {
                if (Object.keys(subscriptionFrequencyData).length > 0 && flags['is-subscription-frequency']) {
                    reqObj.subscription = {
                        duration: subscriptionFrequencyData.duration,
                        interval: subscriptionFrequencyData.subscriptionInterval,
                        type: subscriptionFrequencyData.subscriptionType,
                    };
                } else if (subscriptionDetails
                    && subscriptionDetails.subscriptionDurationKey
                    && subscriptionDetails.subscriptionFrequency
                    && subscriptionDetails.subscriptionType) {
                    let duration = subscriptionDetails.subscriptionDurationKey;
                    if (duration.indexOf('.') > 0) {
                        duration = duration.substring(0, duration.indexOf('.'));
                    }

                    let interval = subscriptionDetails.subscriptionFrequency;
                    if (interval.indexOf('.') > 0) {
                        interval = interval.substring(0, interval.indexOf('.'));
                    }

                    reqObj.subscription = {
                        duration,
                        interval,
                        type: subscriptionDetails.subscriptionType,
                    };
                }
            }

            // Category Page Quickview...
            // 1. Grab the data
            // 2. walk away
            if (isQuickviewOrigin) {
                const payload = {
                    reqObj,
                    history,
                    deliveryType, // FPT or GPT
                    categoryId,
                    productPartNumber,
                    skipAddons,
                    date: selectedDate.date,
                    categoryName,
                    categoryPath,
                    isPassportBundleItem,
                    movieSelected,
                    selectedSku,
                    passportBundle,
                    handleMiniCartModalClick,
                    enableMinicart,
                    close: noop,
                };
                // grab the data
                quickviewSelectDate(payload);
                // walk away
                close();
                return;
            }

            trackEvent({
                eventCategory: 'Product Page',
                eventAction: 'Add to Cart - Calendar',
                eventLabel: productCode,
            });

            trackEvent({
                eventCategory: 'Product Page',
                eventAction: 'Calendar Date Selected',
                eventLabel: format(selectedDate.date, 'yyyy-MM-dd'),
            });

            actionAddToCart(
                reqObj,
                history,
                deliveryType, // FPT or GPT
                categoryId,
                productPartNumber,
                skipAddons,
                selectedDate.date,
                categoryName,
                categoryPath,
                isPassportBundleItem,
                movieSelected,
                selectedSku,
                passportBundle,
                handleMiniCartModalClick,
                enableMinicart,
                close,
                showWrapup,
                null,   // quickviewLocationType
                location,
            );
        } else {
            const payload = {
                updateDeliveryDate: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'MM/dd/yyyy HH:mm:ss'),
                    deliverySLA: selectedDate.data.deliverySLA,
                },
                orderItemId,
            };
            if (selectedDate?.data?.isClickableUnavailableDate
                && clickableUnavailableDates?.fakeDateInfo?.flex_option_id
                && clickableUnavailableDates?.fakeDateInfo?.flex_forceddeldate
                && clickableUnavailableDates?.fakeDateInfo?.flex_date) {
                const { fakeDateInfo } = clickableUnavailableDates;
                const splitForcedDelDate = fakeDateInfo.flex_forceddeldate?.split('-')?.join('/');
                const formattedForcedDelDate = format(new Date(splitForcedDelDate), 'dd-MMM-yy');
                const splitFlexDate = fakeDateInfo.flex_date?.split('-')?.join('/');
                const formattedSplitDate = format(new Date(splitFlexDate), 'dd-MMM-yy');
                payload.updateDeliveryDate.flex = {
                    flexOptionId: fakeDateInfo?.flex_option_id,
                    forcedDate: `${formattedForcedDelDate},${formattedSplitDate}`,
                };
            }

            const updateOrderProps = {
                page: location.pathname.includes('checkout') ? pageType : null,
                updateType: 'delivery',
            };
            actionUpdateOrder(payload, updateOrderProps, close);
            trackEvent({ eventCategory: 'Cart Page', eventAction: 'Delivery Date Updated', eventLabel: format(selectedDate.date, 'yyyy-MM-dd') });
        }
    };

    mouseOverHandler = (surcharge, date) => {
        this.setState({ surcharge, focusedDate: date });
    };

    handleFlexClose = () => {
        this.setState({
            flex: {},
        });
    };

    determineDateColor = (typeOfDate, isFocused, dayHasBanner = false, boxDate = '') => {
        if (typeOfDate === 'unavailable') {
            // unavailable dates do not change their styling based on hovering so this function does not return any additional
            // inline styles for unavailable dates
            return null;
        }
        // The default, unfocused view of a date is a white background with the date text as specific color (determined by CMS)
        // When the user focuses on a date the date text becomes white and the background color becomes what was the date text color
        const { cmsData, inclementWeatherBanner } = this.props;
        const flexHolidayBanner = this.getHolidayBanner();
        const serviceLevels = cmsData?.entries?.[0]?.service_levels || [];
        if (dayHasBanner && inclementWeatherBanner?.banner?.background?.color) {
            const hov = isFocused === true;
            return { color: hov ? inclementWeatherBanner.banner.background.color : '#52297E', background: hov ? '#52297E' : inclementWeatherBanner.banner.background.color };
        }
        if (dayHasBanner && flexHolidayBanner?.banner?.background_color?.color) {
            const dateSpecificStyle = flexHolidayBanner?.date_styling?.day || [];
            const boxStyle = (dateSpecificStyle || []).find((day) => day?.date === boxDate) || null;
            const hov = isFocused === true;
            if (boxStyle && boxStyle?.date) {
                return {
                    color: hov ? boxStyle?.text_color_on_hover?.color || flexHolidayBanner?.banner?.background_color?.color : boxStyle?.text_color?.color || '#52297E',
                    background: hov ? boxStyle?.background_color_on_hover?.color || '#52297E' : boxStyle?.background_color?.color || flexHolidayBanner?.banner?.background_color?.color,
                };
            }
            return { color: hov ? flexHolidayBanner?.banner?.background_color?.color : '#52297E', background: hov ? '#52297E' : flexHolidayBanner?.banner?.background_color?.color };
        }
        if (isFocused === true) {
            if (typeOfDate === 'flex') {
                return {
                    color: 'white', display: 'flex', flexDirection: 'column', background: serviceLevels.find((level) => level.type === typeOfDate)?.color || '#2F7BA6',
                };
            }
            if (serviceLevels.find((level) => level.type === typeOfDate)?.color !== '#52297E') {
                return {
                    color: 'white', background: serviceLevels.find((level) => level.type === typeOfDate)?.color || '#2F7BA6',
                };
            }
            // if focused set the color to white and the background to the right color as determined by CMS.
            return { color: 'white', background: serviceLevels.find((level) => level.type === typeOfDate)?.color || 'black' };
        }
        // else set the color to the CMS determined color and keep the background as its default white
        return { color: serviceLevels.find((level) => level.type === typeOfDate)?.color };
    }

    determineDateType = (dateObj, fakeSurcharge) => {
        // more date types and checks will be added as needed.
        const dateInfo = dateObj.data;
        if (dateInfo === undefined) {
            // If there is no information object in the date object the date is not available
            return 'unavailable';
        }
        if (dateInfo?.flexDetails !== undefined) {
            return 'flex';
        } if (fakeSurcharge || Number(dateInfo.surcharge) > 0 || Number(dateInfo.upcharge) > 0) {
            return 'surcharge';
        }
        return 'regular';
    }

    getFlexSurcharge = (flexDetails) => {
        const { cmsData, presentationFamily } = this.props;
        if (!Array.isArray(flexDetails) || !flexDetails.length) {
            return 0;
        }
        const showLowestAvailbeSurcharge = cmsData?.entries?.[0]?.surcharge_conditions?.show_lowest_available_surcharge;
        // searches through the flex options and finds the highest surcharge if there are multiple
        const surcharge = Math.max(...flexDetails.map((o) => Number(o.flexAmount)));
        const minSurcharge = Math.min(...flexDetails.map((o) => Number(o.flexAmount)));
        return showLowestAvailbeSurcharge && presentationFamily === 'flower' ? minSurcharge.toFixed(2) : surcharge.toFixed(2);
    }

    getFlexSurchargeAll = (flexDetails) => {
        if (!Array.isArray(flexDetails) || !flexDetails.length) {
            return 0;
        }
        const minSurcharge = Math.min(...flexDetails.map((o) => Number(o.flexAmount)));
        return minSurcharge;
    }

    handleUnavailableClickAbleDatePress = (fakeDateInfo) => {
        // this fucntion is used to toggle the modal.
        // the open modal invocation passes fakeDateInfo and that info is used to set state
        // the close modal invocation passes no date info and so fakeDateInfo is reset to empty obj
        const { clickableUnavailableDates } = this.state;
        if (fakeDateInfo) {
            this.setState({
                clickableUnavailableDates: {
                    ...clickableUnavailableDates,
                    unavailableDateModalActive: !clickableUnavailableDates.unavailableDateModalActive,
                    fakeDateInfo,
                },
            });
        } else {
            this.setState({
                clickableUnavailableDates: {
                    ...clickableUnavailableDates,
                    unavailableDateModalActive: !clickableUnavailableDates.unavailableDateModalActive,
                    fakeDateInfo: {},
                },
            });
        }
    }

    determineNegativeSurchargeDisplay = (totSurcharge) => `${'$'}${Math.abs(totSurcharge).toFixed(2)}`

    determineSurchargeDisplay = (totSurcharge) => {
        const { cmsData } = this.props;
        const surchargeDisplayVariant = cmsData?.entries?.[0]?.negative_surcharge_formats || '';
        const negativeSurcharge = null;
        const hasNegativeSurcharge = totSurcharge < 0;
        if (hasNegativeSurcharge) {
            if (negativeSurcharge === 'variant 1' || (surchargeDisplayVariant === 'n off' && !negativeSurcharge)) {
                if (negativeSurcharge === 'variant 1') {
                    return `${'$'}${Math.abs(totSurcharge)}\nOFF`;
                }
                return `${'$'}${Math.abs(totSurcharge).toFixed(2)}\nOFF`;
            }
            if (negativeSurcharge === 'variant 2' || (surchargeDisplayVariant === 'save n' && !negativeSurcharge)) {
                if (negativeSurcharge === 'variant 2') {
                    return `${'SAVE\n$'}${Math.abs(totSurcharge)}`;
                }
                return `${'Save\n$'}${Math.abs(totSurcharge).toFixed(2)}`;
            }
            return `${'-$'}${Math.abs(totSurcharge).toFixed(2)}`;
        }

        return `${'+$'}${Math.abs(totSurcharge).toFixed(2)}`;
    }

    renderWeekDay = (day, dateObj, month, bannerRange = []) => {
        const { focusedDate, dateIcons, clickableUnavailableDates: { clickableDates } } = this.state;
        const {
            classes, cmsData, deliveryType,
        } = this.props;
        this.dataObject = dateObj;
        const negativeSurcharge = null;
        let { available, date } = dateObj;
        const dayHasBanner = bannerRange?.length > 0 ? bannerRange.includes(formatDateYYYY_MM_DD(new Date(date))) : false; const dateToFocus = date;
        const dateIsFocused = compareAsc(new Date(focusedDate), new Date(dateObj.date)) === 0;
        const serviceLevels = cmsData?.entries?.[0]?.service_levels || [];
        const isClickableUnavailableDate = !available && clickableDates && clickableDates[format(new Date(date), 'yyyy/MM/dd')];
        let fakeDateInfo = {};
        if (clickableDates) {
            fakeDateInfo = clickableDates[format(new Date(date), 'yyyy/MM/dd')];
        }
        const actualAddToCartDate = fakeDateInfo?.add_to_cart_date;
        let fakeSurcharge = null;
        if (!available && isClickableUnavailableDate && actualAddToCartDate && this.apiDateObj[actualAddToCartDate]) {
            const addToCartDateData = this.apiDateObj[actualAddToCartDate];
            dateObj.available = true;
            dateObj.data = addToCartDateData;
            if (fakeDateInfo?.is_surcharge_override_enabled && typeof fakeDateInfo?.surcharge !== 'undefined') {
                // by defauly take surcharges and upcharges from the actual add to cart date
                // however there is a cMS option to override that surcharge with a cms specified value
                fakeSurcharge = fakeDateInfo?.surcharge;
            }
            dateObj.data.isClickableUnavailableDate = true;
            const addToCartDateFormatted = addToCartDateData?.deliveryDate?.split('-')?.join('/');
            dateObj.date = new Date(addToCartDateFormatted);
            ({ available, date } = dateObj);
        }
        // The text color and background color of each date is determined by the type of date (surcharge, flex, holiday etc.)
        // and whether the user is currently hovering over that date.
        // The colors used come from CMS.
        // The typeOfDate function determines what type of date an individual date is.
        // the dateStyle functions returns an object that can be consumed by react as an inline style
        // see individual function implementations for descriptions of what they do.
        const { presentationFamily } = this.props;
        const isSurchargeAvailable = cmsData?.entries?.[0] || [];
        const surchargeCondition = isSurchargeAvailable?.surcharge_conditions || {};
        const isSurchargeDisableOnMobile = surchargeCondition?.hide_surcharge_on_mobile && presentationFamily === 'flower';
        const isMobileStyleSurchargeEnabledOnDesktop = surchargeCondition?.enable_mobile_style_surcharge_on_desktop && presentationFamily === 'flower';
        const typeOfDate = this.determineDateType(dateObj, fakeSurcharge);
        const dateStyle = this.determineDateColor(typeOfDate, dateIsFocused, dayHasBanner, format(new Date(dateObj.date), 'yyyy-MM-dd'));
        const formattedDate = format(new Date(dateObj.date), 'yyyy-MM-dd');
        let dateHasIcon = false;
        let dateIconData = null;
        const isHoverDisableOnDesktop = surchargeCondition?.disable_surcharge_hover_on_desktop && presentationFamily === 'flower';
        const calendarCellStyling = isHoverDisableOnDesktop ? classes.renderSurchargeWithoutHover : classes.hoverSurcharge;
        if (dateIcons[formattedDate] && dateIcons[formattedDate]?.icon) {
            dateHasIcon = true;
            dateIconData = { iconData: dateIcons[formattedDate].icon };
        }
        if (date.getMonth() !== month) {
            return (
                <span
                    key={day}
                    className={classes.noDateAvailableRedesign}
                    style={{
                        color: serviceLevels.find((level) => level.type === 'unavailable')?.color || null,
                    }}
                >
                    {/* use &nbsp char to retain box spacing */}
                    &nbsp;
                </span>
            );
        }
        if (!available) {
            return (
                <span
                    key={day}
                    className={classes.noDateAvailableRedesign}
                    style={{
                        border: '1px solid  #b6b5b5',
                        background: `linear-gradient(to top right,
                            rgba(0,0,0,0) 0%,
                            rgba(0,0,0,0) calc(50% - 0.8px),
                            rgba(182,181,181) 50%,
                            rgba(0,0,0,0) calc(50% + 0.8px),
                            rgba(0,0,0,0) 100%),
                            white`,
                    }}
                >
                    <span key={day} className={classes.notVisible}>
                        {dateHasIcon && !dateIsFocused
                            ? (
                                <img
                                    style={dateIsFocused ? { filter: 'brightness(0) saturate(100%) invert(99%) sepia(0%) saturate(1073%) hue-rotate(218deg) brightness(117%) contrast(100%)' } : null}
                                    className={`${classes.dateIcon} ${classes.dateIcon}-unavailable`}
                                    src={dateIconData?.iconData?.url}
                                    alt={dateIconData?.iconData?.name}
                                />
                            )
                            : null}
                        {' '}
                        {day}
                    </span>
                </span>
            );
        }
        const standardCharge = deliveryType === 'FPT' ? 'Standard Service Charge' : 'Standard Shipping Charge';
        let totalSurcharge = fakeSurcharge || (Number(dateObj?.data?.surcharge || 0) + Number(dateObj?.data?.upcharge || 0)).toFixed(2);
        if (dateObj?.data?.flexDetails && Number(totalSurcharge) === 0) {
            totalSurcharge = this.getFlexSurcharge(dateObj.data.flexDetails?.option);
        }
        let serviceChargeText = cmsData?.entries?.[0]?.type?.split(' ')[0] === 'FPT'
            ? 'Service Charge'
            : 'Shipping Charge';
        const hasNegativeSurcharge = Number(totalSurcharge) < 0;
        if (hasNegativeSurcharge) {
            // different text used for negative surcharge dates. || used to provde fallback if no text provided from CMS
            serviceChargeText = cmsData?.entries?.[0]?.negative_surcharge_text || serviceChargeText;
        }
        let serviceCharge;
        if (hasNegativeSurcharge) {
            serviceCharge = `${serviceChargeText} -$${Math.abs(totalSurcharge).toFixed(2)}`;
        } else {
            serviceCharge = `${serviceChargeText} +$${totalSurcharge}`;
        }
        if (dateObj?.data?.flexDetails?.option) {
            const minSurcharge = this.getFlexSurchargeAll(dateObj.data.flexDetails?.option);
            if (Number(minSurcharge) < 0) {
                if (!this.negativeSurchargeAmount) {
                    this.negativeSurchargeAmount = minSurcharge;
                }
                if (!this.lockNegativeSurcharge) {
                    // collecting days those contain the negative price
                    this.negativeSurchargeDates.push(format(new Date(dateObj.date), 'MM/dd'));
                }
            }
        }
        const hasSurcharge = dateObj.data && Number(totalSurcharge) !== 0;
        const isFlexDate = !!dateObj?.data?.flexDetails;
        let flexSideRailMessage = null;
        if (isFlexDate) {
            const unparsedMessage = dateObj?.data?.flexDetails?.option?.[0]?.flexMsg?.find((message) => message.msgType === '6')?.msgText;
            if (unparsedMessage) flexSideRailMessage = sanitizeContent(unparsedMessage);
        }

        const renderSurchargeOnDate = () => (
            <p className={((negativeSurcharge === 'variant 1' || negativeSurcharge === 'variant 2')) ? `${Number(totalSurcharge) < 0 ? `${classes.surchargeV2} ${classes.negativeSurchargeColor}` : classes.surchargeV2}` : classes.surcharge}>
                {Number(totalSurcharge) !== 0 && this.determineSurchargeDisplay(Number(totalSurcharge))}
            </p>
        );

        const surchargeMessage = hasSurcharge
            ? () => {
                this.mouseOverHandler(serviceCharge, dateToFocus);
            }
            : () => (this.mouseOverHandler(standardCharge, dateToFocus));
        return (
            <span
                key={day}
                role="presentation"
                name="7"
                // the mouseOverHandler keeps track of both whether the user is hovering over any date
                // as well as whether the date they are hovering over has a surcharge.
                // if there is a surcharge we change what text we display on the calendar right banner
                // when the user is hovering over that date
                onMouseLeave={
                    hasSurcharge
                        ? () => {
                            this.mouseOverHandler(standardCharge);
                        }
                        : () => (this.mouseOverHandler(standardCharge))
                }
                onMouseEnter={
                    flexSideRailMessage
                        ? () => {
                            this.mouseOverHandler(flexSideRailMessage, dateToFocus);
                        }
                        : surchargeMessage
                }
                onClick={() => {
                    if (isClickableUnavailableDate) {
                        this.handleUnavailableClickAbleDatePress(fakeDateInfo);
                        return;
                    }
                    this.selectDate(dateObj);
                }}
                className={hasSurcharge
                    ? `${classes.dateAvailableV2} ${classes.dateSurcharge} ${calendarCellStyling}`
                    : `${classes.dateAvailableV2} ${calendarCellStyling}`}
                // This is where the styling determined by the above functions is applied
                style={dateStyle}
            >
                <span key={day} className={classes.notVisible}>
                    {/* if the date that the user is currently hovering over has a surcharge then display that surcharge in the cell */}
                    {/* otherwise continue to display the date */}
                    {dateIsFocused && Number(totalSurcharge) !== 0 ? this.determineSurchargeDisplay(Number(totalSurcharge)) : day}
                    {dateHasIcon && !dateIsFocused ? <img style={dateIsFocused ? { filter: 'brightness(0) saturate(100%) invert(99%) sepia(0%) saturate(1073%) hue-rotate(218deg) brightness(117%) contrast(100%)' } : null} className={classes.dateIcon} src={dateIconData?.iconData?.url} alt={dateIconData?.iconData?.name} /> : null}
                </span>
                <DesktopMobile
                    mobile={() => !isSurchargeDisableOnMobile && renderSurchargeOnDate()}
                    desktop={() => isMobileStyleSurchargeEnabledOnDesktop && renderSurchargeOnDate()}
                />
            </span>
        );
    };

    renderMonthTitles = (monthName, year, checkCurrentMonth = false, deliveryDatesInNextMonth, startDayOfWeek, calendar = []) => {
        const { classes } = this.props;
        const { prevBtnCheck } = this.state;
        const prevBtn = checkCurrentMonth && prevBtnCheck ? (
            <span
                role="presentation"
                onClick={() => {
                    this.preMonth();
                }}
                className={classes.prevBtn}
            >
                Prev
            </span>
        ) : null;
        const nextBtn = (checkCurrentMonth && (deliveryDatesInNextMonth || this.isFinalDateDisplayed(calendar))) && (
            <span
                role="presentation"
                onClick={() => {
                    this.nextMonth();
                }}
                className={classes.nextBtn}
            >
                Next
            </span>
        );
        const weekShortNameArr = startDayOfWeek === 0 ? WWW_WEEKDAY_SHORTNAMES_SUN_START : WWW_WEEKDAY_SHORTNAMES_MON_START;
        return (
            <div className={classes.weekDayName}>
                <div className={classes.monthTitle}>
                    {prevBtn}
                    {monthName} {year}
                    {nextBtn}
                </div>
                {weekShortNameArr.map((name) => (
                    <span key={name} className={classes.weekDayV2}>
                        {name}
                    </span>
                ))}
            </div>
        );
    };

    closeAndResetState = () => {
        const { close } = this.props;
        close();
        this.setState({
            prevBtnCheck: false,
            surcharge: 'Standard Service Charge',
            now: '',
            end: '',
            spinnerActive: false,
        });
    };

    getHolidayBanner = () => {
        const { cmsData } = this.props;
        const flexBanner = cmsData?.entries?.[0]?.flex_holiday_banner;
        if (flexBanner && flexBanner?.holiday_date_range?.start_date && flexBanner?.holiday_date_range?.end_date) {
            return flexBanner;
        }
        return null;
    }

    render() {
        const {
            flexTaggingData, surcharge, now, end, spinnerActive, flex, altCalendar: { altCalendarActivated, altCalendarData }, clickableUnavailableDates,
        } = this.state;
        const {
            isOpen, /* close, */ classes, cmsData, todayTomDateNotAvailText, userSubmittedZip,
            cartError, addToCartError, flags, deliveryType, zipCode, inclementWeatherBanner,
            orderItemRecipientError, orderItemId,
            deviceType, trackEvent, ldClient, pageType, brandId,
        } = this.props;

        const cartServiceError = orderItemRecipientError?.[orderItemId]?.deliveryDate?.errorMessage || '';
        const calendarBannerIcon = cmsData?.entries?.[0]?.flex_banner?.[0]?.icon?.url;
        const experimentCalendarFlag = ldClient?.variation?.(`experiment-calendar-first-weeday-sunday-${deliveryType === 'FPT' ? 'fpt' : 'gpt'}`);
        const startDayOfWeek = flags[`is-floral-calendar-first-day-of-week-sunday-${deliveryType?.toLowerCase?.()}`] && experimentCalendarFlag?.toLowerCase() !== 'control' ? 0 : 1;
        const flexHolidayBanner = this.getHolidayBanner();
        let ranges = [];

        let holidayBannerInWeekRange = false;
        if (flags['is-calendar-holiday-banner-enabled'] && flexHolidayBanner?.holiday_date_range?.start_date && flexHolidayBanner?.holiday_date_range?.end_date) {
            const currentWeek = getWeek(new Date(), { weekStartsOn: startDayOfWeek });
            const holidayBannerStartWeek = getWeek(yyyy_mm_ddToDate(flexHolidayBanner?.holiday_date_range?.start_date), { weekStartsOn: startDayOfWeek });
            const holidayBannerEndWeek = getWeek(yyyy_mm_ddToDate(flexHolidayBanner?.holiday_date_range?.end_date), { weekStartsOn: startDayOfWeek });
            if (compareAsc(yyyy_mm_ddToDate(flexHolidayBanner?.holiday_date_range?.end_date), yyyy_mm_ddToDate(formatDateYYYY_MM_DD(new Date()))) >= 0) {
                if (
                    ((holidayBannerStartWeek - currentWeek) <= 5 && (holidayBannerStartWeek - currentWeek) >= 0)
                    || ((holidayBannerEndWeek - currentWeek) <= 5 && (holidayBannerEndWeek - currentWeek) >= 0)) {
                    holidayBannerInWeekRange = true;
                }
            }
        }
        const isHolidayBannerEnabled = flags['is-calendar-holiday-banner-enabled'] && holidayBannerInWeekRange;

        if ((flags['is-calendar-inclement-weather-banner-enabled']) || isHolidayBannerEnabled) {
            if (inclementWeatherBanner && inclementWeatherBanner?.date_range?.start_date && inclementWeatherBanner?.date_range?.end_date) {
                ranges = this.generateDaysByRange(inclementWeatherBanner?.date_range?.start_date, inclementWeatherBanner?.date_range?.end_date);
            } else if (isHolidayBannerEnabled && !inclementWeatherBanner && flexHolidayBanner && flexHolidayBanner?.holiday_date_range?.start_date && flexHolidayBanner?.holiday_date_range?.end_date) {
                ranges = this.generateDaysByRange(flexHolidayBanner?.holiday_date_range?.start_date, flexHolidayBanner?.holiday_date_range?.end_date);
            }
        }
        if (!cmsData?.entries?.[0]) {
            return null;
        }
        const serviceLevels = cmsData?.entries?.[0]?.service_levels || [];
        const deliveryImage = cmsData?.entries?.[0]?.local_florist_delivery_icon !== null
            ? cmsData?.entries?.[0]?.local_florist_delivery_icon?.url
            : cmsData?.entries?.[0]?.shipping_in_gift_box_icon?.url;
        const clickableUnavailableMessaging = clickableUnavailableDates?.fakeDateInfo?.messaging;
        let unavailableClickAddToCartDateObj;
        if (clickableUnavailableDates.unavailableDateModalActive && typeof clickableUnavailableDates?.fakeDateInfo?.add_to_cart_date !== 'undefined') {
            unavailableClickAddToCartDateObj = this.apiDateObj[clickableUnavailableDates.fakeDateInfo.add_to_cart_date];
        }
        if (!now) {
            return null;
        }
        let shippingMessage = '';
        if (flags['is-calendar-negative-surcharge-message-enabled'] && this.negativeSurchargeDates.length > 0) {
            if (this.negativeSurchargeDates.length === 1 || (this.negativeSurchargeDates.length === 2 && this.negativeSurchargeDates[0] === this.negativeSurchargeDates[1])) {
                shippingMessage = (
                    <span>
                        Order early on <b> {this.negativeSurchargeDates[0]} </b> & save <b> {this.determineNegativeSurchargeDisplay(Number(this.negativeSurchargeAmount))} </b> on shipping
                    </span>
                );
            } else {
                shippingMessage = (
                    <span>
                        Order early on <b> {this.negativeSurchargeDates[0]} - {this.negativeSurchargeDates[this.negativeSurchargeDates.length - 1]} </b> & save <b> {this.determineNegativeSurchargeDisplay(Number(this.negativeSurchargeAmount))} </b> on shipping
                    </span>
                );
            }
        }
        const calendar = this.generateCalendar(now, end, startDayOfWeek);
        const nextMonth = firstOfNextMonth(now);
        const currentMonthArray = this.generateMonth(
            calendar,
            getWeek(startOfMonth(new Date(now)), { weekStartsOn: startDayOfWeek }),
            getWeek(endOfMonth(new Date(now)), { weekStartsOn: startDayOfWeek }),
        );
        let nextMonthArray = [];
        if (!isSameMonth(now, end)) {
            nextMonthArray = this.generateMonth(
                calendar,
                getWeek(new Date(nextMonth), { weekStartsOn: startDayOfWeek }),
                getWeek(endOfMonth(new Date(nextMonth)), { weekStartsOn: startDayOfWeek }),
            );
        }

        const renderCalendarMonths = (
            <DialogTitle className={`${classes.dialogTitle} ${classes.calendarBoxV2}`}>
                {isHolidayBannerEnabled && !inclementWeatherBanner && flexHolidayBanner && (<CalendarBanner deliveryType={deliveryType} data={flexHolidayBanner} flags={flags} calendarBannerIcon={calendarBannerIcon} />)}
                {flags['is-calendar-inclement-weather-banner-enabled'] && inclementWeatherBanner && (<CalendarBanner deliveryType={deliveryType} weatherBanner data={inclementWeatherBanner} />)}
                <div className={classes.calendarMobileLayout}>
                    {this.renderMonthTitles(
                        MMMM_MONTH_NAMES[now.getMonth()],
                        getYear(now),
                        true,
                        nextMonthArray.length >= 0,
                        startDayOfWeek,
                        calendar,
                    )}
                    {currentMonthArray.map((week) => (
                        <div
                            key={formatDateYYYY_MM_DD(week[0].date)}
                            className={classes.daysRow}
                        >
                            {week.map((day) => this.renderWeekDay(
                                z2fmt(day.date.getDate()),
                                day,
                                now.getMonth(),
                                ranges,
                            ))}
                        </div>
                    ))}
                    {spinnerActive ? (
                        <div className={classes.spinnerContainer}>
                            <CircularProgress
                                className={classes.spinner}
                            />
                        </div>
                    ) : null}
                    {nextMonthArray.length > 0 && this.renderMonthTitles(
                        MMMM_MONTH_NAMES[nextMonth.getMonth()],
                        getYear(end),
                        false,
                        null,
                        startDayOfWeek,
                    )}
                    {nextMonthArray.map((week) => (
                        <div
                            key={formatDateYYYY_MM_DD(week[0].date)}
                            className={classes.daysRow}
                            data-date={formatDateYYYY_MM_DD(week[0].date)}
                        >
                            {week.map((day) => this.renderWeekDay(
                                z2fmt(day.date.getDate()),
                                day,
                                now.getMonth() === 11
                                    ? 0
                                    : now.getMonth() + 1,
                                ranges,
                            ))}
                        </div>
                    ))}
                    {deviceType !== 'desktop' && shippingMessage && this.negativeSurchargeAmount && this.negativeSurchargeDates.length > 0
                        && (
                            <div className={classes.negativeSurchargeMessage}>
                                <p>
                                    {shippingMessage}
                                    <span className={classes.negativeSurchargeIcon}>
                                        <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt2bdb1ca2caa3d4a5/63c6e090897bff1483453c9c/Sparkles_Icon.svg" alt="negative_surcharge_banner" />
                                    </span>
                                </p>
                            </div>
                        )}
                    {(deviceType !== 'desktop') && (
                        <div className={classes.mobBottomDiv}>
                            <div className={classes.mobBottomLeft}>
                                <ServiceLabel serviceLevels={serviceLevels} />
                            </div>
                            {altCalendarActivated && (
                                <div className={classes.altCalendarMobile}>
                                    <AltCalendarWidget
                                        zipCodeValue={zipCode}
                                        altCalendarData={altCalendarData}
                                        trackEvent={trackEvent}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </DialogTitle>
        );

        return (
            <div>
                {clickableUnavailableDates.unavailableDateModalActive
                    && unavailableClickAddToCartDateObj
                    && (
                        <UnavailableDateModal
                            addToCartDate={unavailableClickAddToCartDateObj}
                            messaging={clickableUnavailableMessaging}
                            isOpen={clickableUnavailableDates.unavailableDateModalActive}
                            selectDate={this.selectDate}
                            onClose={this.handleUnavailableClickAbleDatePress}
                            fakeDateInfo={clickableUnavailableDates?.fakeDateInfo}
                            userSubmittedZip={userSubmittedZip}
                            deliveryType={deliveryType}
                        />
                    )}

                <Dialog
                    className={`${classes.modelContainer} ${((addToCartError || cartServiceError || cartError) ? classes.maxClosedWidth : null)}`}
                    open={isOpen}
                    classes={
                        spinnerActive
                            ? {
                                paper: classes.loadingFadeOut,
                            }
                            : null
                    }
                >
                    {(!addToCartError && !cartError && !cartServiceError) && (
                        <>
                            {flex?.flexActivated === true ? '' : (
                                <div className={classes.modelHeader}>
                                    SELECT DELIVERY DATE
                                    <span
                                        onClick={this.closeAndResetState}
                                        role="presentation"
                                        className={classes.closeModal}
                                        id="close-full-calendar"
                                        data-test="pdp-close-full-calendar"
                                        name="closeFullCalendar"
                                    >
                                        X
                                    </span>
                                </div>
                            )}
                            {todayTomDateNotAvailText
                                ? (
                                    <div className={classes.todayTomDateNotAvailContainer}>
                                        <p>
                                            {todayTomDateNotAvailText}
                                        </p>
                                    </div>
                                ) : null}
                            {flex?.flexActivated === true ? (
                                <FlexibleShippingOptions
                                    flexTaggingData={flexTaggingData}
                                    cmsData={cmsData}
                                    flexData={flex?.flexData}
                                    isOpen={flex?.flexActivated}
                                    handleFlexClose={this.handleFlexClose}
                                    flexAddToCart={this.flexAddToCart}
                                    dateFlexImage={flex?.dateFlexImage}
                                    closeAndResetState={this.closeAndResetState}
                                    selectDate={this.selectDate}
                                    dataObject={this.dataObject}
                                    classes={classes}
                                    isCalendarV2Enabled={this.isCalendarV2Enabled()}
                                    shippingMessage={shippingMessage}
                                    negativeSurchargeAmount={this.negativeSurchargeAmount}
                                    negativeSurchargeDates={this.negativeSurchargeDates}
                                    pageType={pageType}
                                    weatherBanner={flags['is-calendar-inclement-weather-banner-enabled'] && inclementWeatherBanner && (<CalendarBanner deliveryType={deliveryType} weatherBanner data={inclementWeatherBanner} />)}
                                    brandId={brandId}
                                    flex={flex}
                                />
                            ) : renderCalendarMonths}
                            {deviceType === 'desktop'
                                && (
                                    <div className={classes.dialogTitle} style={{ visibility: flex?.flexActivated === true && 'hidden' }}>
                                        <div className={classes.divider} />
                                        <div className={classes.bottomContent}>
                                            <div className={classes.mobBottomDiv}>
                                                <div className={`${classes.mobBottomLeft} mobBottomLeft mobBottomLeftV2`}>
                                                    {shippingMessage && this.negativeSurchargeAmount && this.negativeSurchargeDates.length > 0
                                                        && (
                                                            <div className={classes.negativeSurchargeMessage}>
                                                                <p>
                                                                    {shippingMessage}
                                                                    <span className={classes.negativeSurchargeIcon}>
                                                                        <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt2bdb1ca2caa3d4a5/63c6e090897bff1483453c9c/Sparkles_Icon.svg" alt="negative_surcharge_banner" />
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        )}
                                                    <ServiceLabel serviceLevels={serviceLevels} isDesktop />
                                                </div>
                                                {altCalendarActivated && (
                                                    <div className={classes.altCalendarMobile}>
                                                        <AltCalendarWidget
                                                            zipCodeValue={zipCode}
                                                            altCalendarData={altCalendarData}
                                                            trackEvent={trackEvent}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </>
                    )}
                    {
                        (addToCartError || cartServiceError || cartError) && (
                            <>
                                <div className={`${classes.modelHeader} ${classes.closeModalEmpty}`}>
                                    <span
                                        onClick={this.closeAndResetState}
                                        role="presentation"
                                        className={classes.closeModal}
                                        id="close-full-calendar"
                                        data-test="pdp-close-full-calendar"
                                        name="closeFullCalendar"
                                    >
                                        X
                                    </span>
                                </div>
                                <DialogTitle>
                                    <p className={classes.cartError}><ErrorOutlineIcon className={classes.errorIcon} />{sanitizeContent(addToCartError || cartServiceError || cartError)}</p>
                                </DialogTitle>
                            </>
                        )
                    }
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cartError: getCartError(state),
    addToCartError: getAddToCartError(state),
    orderItemRecipientError: getOrderItemErrors(state),
    validatedZip: getValidatedZipcode(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    loader: getLoaderStatus(state),
    addToCartLoader: getAddToCartLoaderStatus(state),
    isCheckout: isCheckoutPage(),
    flags: getFeatureFlags(state),
    passportInCart: getPassportSubscriptionStatus(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    isUserLoggedIn: getIsAuthenticatedStatus(state),
    pmallSummaryInfo: getPmallSummaryInfo(state),
    subscriptionFrequencyData: getSubscriptionFrequencyData(state),
    presentationFamily: getPresentationFamily(state),
    deviceType: getSSRDeviceType(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionAddToCart: bindActionCreators(addToCart, dispatch),
    actionUpdateOrder: bindActionCreators(updateOrder, dispatch),
    clearCartError: bindActionCreators(errorActions.clearErrors, dispatch),
    callClearAddToCartError: bindActionCreators(clearAddToCartError, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});

CalendarModal.propTypes = {
    classes: object.isRequired,
    isOpen: bool.isRequired,
    close: func.isRequired,
    locationType: string.isRequired,
    actionAddToCart: func.isRequired,
    brandId: string.isRequired,
    selectedItemId: string,
    // validatedZip: string.isRequired,
    history: object.isRequired,
    cmsData: object.isRequired,
    userSubmittedZip: string.isRequired,
    setCalendarDataLoadingFlag: func.isRequired,
    handleDeliveryAvailability: func.isRequired,
    location: object.isRequired,
    actionUpdateOrder: func.isRequired,
    orderItemId: string,
    deliveryType: string,
    ageDetails: shape({
        birthDay: string,
        birthMonth: string,
        birthYear: string,
        minAge: string,
    }).isRequired,
    partNumber: string.isRequired,
    todayTomDateNotAvailText: string,
    sympathyValue: string,
    pageType: string,
    clearCartError: func,
    callClearAddToCartError: func,
    cartError: string,
    orderItemRecipientError: object.isRequired,
    zipCode: string,
    trackEvent: func.isRequired,
    isInternationalProduct: bool,
    internationalCountry: string,
    flags: object.isRequired,
    isPassportBundleItem: bool,
    personalization: shape({
        indicator: string,
        lineState: arrayOf(
            shape({
                lineNumber: number.isRequired,
                maxChars: number.isRequired,
            }).isRequired,
        ),
        modalOpen: bool.isRequired,
    }).isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: shape({
            value: number,
        }),
        passportSku: string,
        enable: bool,
    }),
    selectedSku: shape({
        prices: arrayOf(shape({
            type: string,
            value: number,
        })),
    }).isRequired,
    hasWine: string,
    isFlowersSubscriptionFeatureEnabled: bool.isRequired,
    isFlowersTempV1SubscriptionFeatureEnabled: bool.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    handleMiniCartModalClick: func.isRequired,
    enableMinicart: bool.isRequired,
    passportInCart: bool,
    isPassportUser: bool,
    isUserLoggedIn: bool,
    addToCartError: string,

    /**
     * Props pertaining to the Category Quickview Feature
     * @define {isQuckviewOrigin} flag for calendar to know if its used from quickview or not.
     * @define {quickviewSelectDate} function to return the selected date to the quickview component.
     */
    isQuickviewOrigin: bool,
    quickviewSelectDate: func,
    pmallSummaryInfo: shape({
        customizations: arrayOf(
            shape({
                refnum: string,
                description: string,
                'preview-url': string,
            }),
        ),
    }).isRequired,
    subscriptionTypeAttribute: string,
    subscriptionFrequencyData: shape({
        duration: string,
        subscriptionType: string,
    }),
    showWrapup: string,
    auth: object.isRequired,
    inclementWeatherBanner: object,
    presentationFamily: string.isRequired,
    deviceType: string,
    ldClient: object.isRequired,
};

CalendarModal.defaultProps = {
    selectedItemId: null,
    orderItemId: '',
    callClearAddToCartError: noop,
    clearCartError: noop,
    deliveryType: '',
    todayTomDateNotAvailText: '',
    pageType: '',
    cartError: '',
    zipCode: null,
    isInternationalProduct: false,
    internationalCountry: '',
    isPassportBundleItem: false,
    movieSelected: null,
    isPassportBundleProduct: {},
    hasWine: 'false',
    subscriptionDetails: {},
    subscription: {},
    passportInCart: false,
    isPassportUser: false,
    isUserLoggedIn: false,
    sympathyValue: null,
    addToCartError: '',
    isQuickviewOrigin: false,
    quickviewSelectDate: noop,
    subscriptionTypeAttribute: null,
    subscriptionFrequencyData: {},
    showWrapup: 'true',
    inclementWeatherBanner: null,
    deviceType: '',
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
    withAuth,
)(CalendarModal);
